"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_leaflet_1 = require("react-leaflet");
const leaflet_1 = __importDefault(require("leaflet"));
const icons_1 = require("./icons");
const icon = leaflet_1.default.icon({ iconUrl: icons_1.markerIcon, iconAnchor: [16, 30] });
const Overlays = props => {
    const mapObjects = [];
    props.points.forEach((point, i) => mapObjects.push(react_1.default.createElement(react_leaflet_1.Marker, { position: point, key: "m" + i, icon: icon })));
    props.circles.forEach((circle, i) => mapObjects.push(react_1.default.createElement(react_leaflet_1.Circle, Object.assign({}, circle, { key: "c" + i }))));
    props.rectangles.forEach((rectangle, i) => mapObjects.push(react_1.default.createElement(react_leaflet_1.Rectangle, { bounds: rectangle, key: "r" + i })));
    props.polylines.forEach((polyline, i) => mapObjects.push(react_1.default.createElement(react_leaflet_1.Polyline, { positions: polyline, key: "l" + i })));
    props.polygons.forEach((polygon, i) => mapObjects.push(react_1.default.createElement(react_leaflet_1.Polygon, { positions: polygon, key: "p" + i })));
    return react_1.default.createElement(react_1.default.Fragment, null, mapObjects);
};
exports.default = Overlays;
